export enum Cookie {
  auth = 'mogul:auth',
}
